export default __webpack_public_path__ + "static/media/Group_3406_blue@2x.9130b80a.png";